export default __webpack_public_path__ + "static/3-3940a1a8d7c4f4977c91f2d834aa611f.jpeg";